import { useIntl } from 'react-intl';
import { Flex } from '@/ui/Flex/Flex';
import { IconLanguage, IconTouchPrimary } from '@/icons';
import { T } from '@/ui/Text/Text';
import CustomSelect from '@/ui/Select/Select';
import HorizontalDivider from '@/ui/HorizontalDivider';
import { GeneralSettingsType, LanguageOptions } from '../types';
import { SensorTouchNodeType } from '../../Nodes/types';
import { StyledSettings, StyledSettingsContent } from '../styles';
import FAQSection from '../FAQSection';

function TouchSettings({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  settings,
  selectedNode,
  updateNodeData,
  disabled,
}: {
  settings: GeneralSettingsType;
  selectedNode: SensorTouchNodeType;
  updateNodeData: (id: string, newData: any) => void;
  disabled?: boolean;
}) {
  const relevantData = selectedNode.data.options;
  const intl = useIntl();

  const faqs = [
    ...(settings.languageSelective
      ? [
          {
            question: intl.formatMessage({
              defaultMessage: 'What is the purpose of Language in this block?',
              id: 'Yg3yKs',
            }),
            answer: intl.formatMessage({
              defaultMessage:
                'Language defines under which language the logic for a touch event should work. If it is set to "Any", the logic for a touch event will work on any language.',
              id: '0BTDzS',
            }),
          },
        ]
      : []),
  ];
  return (
    <StyledSettings data-testid="sensor-touch-settings">
      <Flex align="center" gap={8}>
        <IconTouchPrimary />
        <Flex direction="column">
          <T h3>
            {intl.formatMessage({
              defaultMessage: 'Touch',
              id: 'lDEhUP',
            })}
          </T>
        </Flex>
      </Flex>
      <StyledSettingsContent>
        {settings.languageSelective && (
          <Flex direction="column" gap={8}>
            <Flex justify="space-between" align="center">
              <T body1>
                {intl.formatMessage({
                  defaultMessage: 'Works in Language',
                  id: 'M+Dbq2',
                })}
              </T>
              <CustomSelect
                disabled={disabled ?? false}
                icon={<IconLanguage />}
                isSearchable={false}
                size="small"
                placeholder="DE"
                options={LanguageOptions.map((lang) => ({
                  label: lang.value
                    ? lang.value
                    : intl.formatMessage({
                        defaultMessage: 'Any',
                        id: 'ToO3/h',
                      }),
                  value: lang.value,
                }))}
                value={
                  relevantData.language
                    ? {
                        label: relevantData.language,
                        value: relevantData.language,
                      }
                    : {
                        label: intl.formatMessage({
                          defaultMessage: 'Any',
                          id: 'ToO3/h',
                        }),
                        value: null,
                      }
                }
                onChange={(e) => {
                  updateNodeData(selectedNode.id, {
                    ...selectedNode.data,
                    options: {
                      ...relevantData,
                      language: e?.value,
                    },
                  });
                }}
              />
            </Flex>
          </Flex>
        )}
        <HorizontalDivider />
      </StyledSettingsContent>

      <FAQSection faqs={faqs} />
    </StyledSettings>
  );
}

export default TouchSettings;
